module.exports = __webpack_public_path__ + "img/nz.82cf1222.svg";